import React from 'react';

import Logo from '../icons/Logo';

import styles from './loginbox.scss';

const LoginBox = ({ children }) =>
  <div className="login-box">
    <div className="logo">
      <div className="temp-logo">
        LIGHTPLANNER
      </div>
    </div>
    {children}
  </div>

export default LoginBox;



// WEBPACK FOOTER //
// ./src/components/layout/LoginBox.js